import { render, staticRenderFns } from "./DetailsPersonal.vue?vue&type=template&id=cfe3bf9e&scoped=true&"
import script from "./DetailsPersonal.vue?vue&type=script&lang=js&"
export * from "./DetailsPersonal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPersonal.vue?vue&type=style&index=0&id=cfe3bf9e&prod&lang=scss&scoped=true&"
import style1 from "./DetailsPersonal.vue?vue&type=style&index=1&id=cfe3bf9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe3bf9e",
  null
  
)

export default component.exports